// Original StyledConfig type extends object so matching here
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/styled-components/index.d.ts#L125
var generateShouldForwardPropsConfig = function generateShouldForwardPropsConfig(propsToNotForward) {
  return {
    shouldForwardProp: function shouldForwardProp(prop, defaultValidatorFn) {
      return (// the `prop` type is keyof T (coming from StyledConfig), and `keyof` resolves to string | number | symbol
        // calling `.toString` to always pass a string into `Array.includes()`
        // https://stackoverflow.com/a/51808262
        !propsToNotForward.includes(prop.toString()) && defaultValidatorFn(prop)
      );
    }
  };
};

export { generateShouldForwardPropsConfig };
